import React, { useState } from "react"
import Select from "react-select"
import theme from "../../styles/theme"
import PropTypes from "prop-types"

const customStyles = {
  option: (provided, state) => ({
    ...provided,
    borderBottom: `1px dotted ${theme.colors.black}`,
    color: state.isSelected ? theme.colors.red : theme.colors.green,
    padding: "15px 20px",
    fontFamily: "IBM Plex Sans",
    fontWeight: 600,
    zIndex: 100,
  }),
  placeholder: (provided, state) => ({
    ...provided,
    fontFamily: "IBM Plex Sans",
    fontWeight: 600,
  }),
  control: (provided, state) => ({
    // none of react-select's styles are passed to <Control />
    ...provided,
    width: "100%",
    backgroundColor: theme.colors.black,
    borderColor: theme.colors.whiteOp,
    borderRadius: 0,
    boxShadow: state.isSelected ? `0 0 0 1px ${theme.colors.green}` : "none",
  }),
  singleValue: (provided, state) => {
    const opacity = state.isDisabled ? 0.5 : 1
    const transition = "opacity 300ms"

    return { ...provided, opacity, transition }
  },
}

const CategorySelector = ({ categories, language, updateFilter }) => {
  // select all categories with parent category Species
  const speciesOptions = selected =>
    selected
      ? selected
      : categories
          .map(
            cat =>
              cat.node.parents.length > 0 &&
              cat.node.parents[0]._rawTitle.en === "Species" && {
                label: cat.node.title.translate,
                value: cat.node._rawSlug[language]?.current || "Unset",
                parent: cat.node.parents[0]._rawTitle.en,
              }
          )
          .filter(item => item !== false)
          .sort((a, b) => {
            if (a.label < b.label) return -1
            if (b.label < a.label) return 0
            return 0
          })

  const [species, setSpecies] = useState(() => speciesOptions(null))

  // select all categories with parent category Products
  const productOptions = categories
    .map(
      cat =>
        cat.node.parents.length > 0 &&
        cat.node.parents[0]._rawTitle.en === "Product" && {
          label: cat.node.title.translate,
          value: cat.node._rawSlug[language]?.current || "Unset",
          parent: cat.node.parents[0]._rawTitle.en,
        }
    )
    .filter(item => item !== false)
    .sort((a, b) => {
      if (a.label < b.label) return -1
      if (b.label < a.label) return 0
      return 0
    })

  const groupedOptions = [
    {
      label: "Species",
      options: species,
    },
    {
      label: "Products",
      options: productOptions,
    },
  ]

  const multiUpdate = e => {
    // check if the selected category is a species category
    const isSpecies = e.filter(item => {
      const match = species.map(spec => item.label.indexOf(spec.label) > -1)
      return match.some(i => i === true)
    })
    if (isSpecies) {
      // there is at least one species selected
      if (e.length > 0) {
        const updatedSpeciesOptions = speciesOptions(e)
        setSpecies(updatedSpeciesOptions)
        updateFilter(e)
      } else {
        // no species selected
        const updatedSpeciesOptions = speciesOptions(null)
        setSpecies(updatedSpeciesOptions)
        updateFilter(e)
      }
    }
  }

  return (
    <Select
      isMulti
      name="colors"
      options={groupedOptions}
      className="category-select"
      classNamePrefix="select"
      onChange={e => multiUpdate(e)}
      clearValue={e => multiUpdate(e)}
      styles={customStyles}
      placeholder={"Filter by category"}
      className={"customReactSelect"}
    />
  )
}

CategorySelector.propTypes = {
  categories: PropTypes.array.isRequired,
  language: PropTypes.string,
  updateFilter: PropTypes.func.isRequired,
}

CategorySelector.defaultProps = {
  language: "en",
}

export default CategorySelector
